import { findAppFromStoreByAppName } from "helpers/brand";
import { hasAppPermission } from "helpers/chrome/locations";
import type { IEntity } from "interfaces/app";

import { type FeatureFlags, LD_FEATURE_FLAGS } from "types/context";

/** Matches `BREADCRUMB_PERMISSIONS.REPORTS` in `helpers/chrome/locations`. */
const BREADCRUMB_ADMINACCESS_REPORTS = "adminaccessReports" as const;

/**
 * Audit Logs requires LaunchDarkly flags plus Breadcrumb POS permission
 * `adminaccess_reports`, or umbrella permission `all`, on the relevant store(s)
 * (see `hasAppPermission` / locations API `permissions` on the breadcrumb app).
 */
function hasAuditLogsBreadcrumbAccess(store?: IEntity | null): boolean {
  if (!store) {
    return false;
  }
  const app = findAppFromStoreByAppName("breadcrumb", store);
  return app ? hasAppPermission(app, BREADCRUMB_ADMINACCESS_REPORTS) : false;
}

/** Sidebar / main-view gate: LaunchDarkly plus Breadcrumb reports permission. */
export const isAuditLogFeatureEnabled = (
  featureFlags: FeatureFlags,
  store?: IEntity | null
) => {
  if (!featureFlags[LD_FEATURE_FLAGS.auditLogPOS]) {
    return false;
  }
  const ldCategoryEnabled =
    !!featureFlags[LD_FEATURE_FLAGS.auditLogChecksCategory] ||
    !!featureFlags[LD_FEATURE_FLAGS.auditLogServersCategory] ||
    !!featureFlags[LD_FEATURE_FLAGS.auditLogDevicesCategory] ||
    !!featureFlags[LD_FEATURE_FLAGS.auditLogPrintersCategory];

  if (!ldCategoryEnabled) {
    return false;
  }

  return hasAuditLogsBreadcrumbAccess(store);
};
